import React, { useState, useRef, useEffect } from "react";

import Slider from "react-slick";



function Productdetailscarousel({ items }) {

  const imageref = useRef(null);

  const [showZoom, setShowZoom] = useState(false);

  const [backgroundPos, setBackgroundPos] = useState("0% 0%");

  const [mainSlider, setMainSlider] = useState(null);

  const [thumbSlider, setThumbSlider] = useState(null);



  useEffect(() => {

    setNav1(mainSlider);

    setNav2(thumbSlider);

  }, [mainSlider, thumbSlider]);



  const [nav1, setNav1] = useState();

  const [nav2, setNav2] = useState();



  const handleMousemove = (e) => {

    const rect = imageref.current.getBoundingClientRect();



    let x = ((e.clientX - rect.left) / rect.width) * 100;

    let y = ((e.clientY - rect.top) / rect.height) * 100;



    x = Math.max(0, Math.min(100, x));

    y = Math.max(0, Math.min(100, y));



    setBackgroundPos(`${x.toFixed(2)}% ${y.toFixed(2)}%`);

  };



  console.log(backgroundPos);



const images = [items.product_image, items.productsub_image].filter(Boolean);
if (items.product_video && items.product_video.trim() !== "") {
  images.push("video");
}




  const mainSettings = {

    asNavFor: nav2,

    ref: setMainSlider,

    dots: false,

    infinite: true,

    speed: 400,

    slidesToShow: 1,

    slidesToScroll: 1,

    arrows: false,

  };



  const thumbSettings = {

    asNavFor: nav1,

    ref: setThumbSlider,

    slidesToShow: images.length >= 3 ? 3 : images.length,

    swipeToSlide: true,

    focusOnSelect: true,

    arrows: false,

  };



  return (

    <div className="product-carousel-wrapper">

      <Slider {...mainSettings}>

        {images.map((data, index) => (

          <div key={index}>

            {data === "video" ? (

              <video

                src={items.product_video}

                controls

                autoPlay

                muted

                loop

                playsInline

                style={{ width: "100%", maxHeight: 400, borderRadius: 8 }}

              />

            ) : (

              <div

                className="image-wrapper"

                ref={imageref}

                onMouseEnter={() => setShowZoom(true)}

                onMouseMove={handleMousemove}

                onMouseLeave={() => setShowZoom(false)}

              >

                <img src={data} alt="Product" />

                {showZoom && (

                  <div

                    className="zoom-result"

                    style={{

                      backgroundImage: `url(${data})`,

                      backgroundPosition: backgroundPos,

                    }}

                  />

                )}

              </div>

            )}

          </div>

        ))}

      </Slider>



      {/* Thumbnail Slider */}

      <div className="thumbnail-slider">

        <Slider {...thumbSettings}>

          {images.map((data, index) => (

            <div key={index} className="thumbnail-item">

              {data === "video" ? (

                <video

                  src={items.product_video}

                  muted

                  style={{ height: 60, borderRadius: 6 }}

                />

              ) : (

                <img

                  src={data}

                  alt="Thumb"

                  style={{ height: 60, borderRadius: 6 }}

                />

              )}

            </div>

          ))}

        </Slider>

      </div>

    </div>

  );

}



export default Productdetailscarousel;

